import EcsContact from './EcsContact';
import { CONTACT_TYPE } from '@/constants/contactConstants';

export default class EcsExternalContact extends EcsContact {
  get contactType() {
    return CONTACT_TYPE.external;
  }

  get isExternalContact() {
    return true;
  }

  get isInternalContact() {
    return false;
  }

  get phones() {
    return this.contactDetailData
      .filter(
        contactDetail =>
          contactDetail.uri &&
          contactDetail.mediaType === 'Telephony' &&
          !contactDetail.name.toLowerCase().includes('mobile')
      )
      .map(contactDetail => ({
        description: contactDetail.name,
        value: contactDetail.uri
      }));
  }

  get mobiles() {
    return this.contactDetailData
      .filter(
        contactDetail =>
          contactDetail.uri &&
          contactDetail.mediaType === 'Telephony' &&
          contactDetail.name.toLowerCase().includes('mobile')
      )
      .map(contactDetail => ({
        description: contactDetail.name,
        value: contactDetail.uri
      }));
  }

  get emails() {
    return this.contactDetailData
      .filter(contactDetail => contactDetail.uri && ['Email', 'Primary Email'].includes(contactDetail.mediaType))
      .map(contactDetail => ({
        description: contactDetail.name,
        value: contactDetail.uri
      }));
  }

  get endPoint() {
    const defaultEnpoint = this.mobiles.length ? this.mobiles[0].value : null;
    return this.phones.length ? this.phones[0].value : defaultEnpoint;
  }

  get isSMSEnabled() {
    return this.mobiles.length > 0;
  }

  get searchString() {
    const phones = this.phones.map(phone => phone.value);
    const mobiles = this.mobiles.map(mobile => mobile.value);
    const emails = this.emails.map(email => email.value);
    return [...phones, ...mobiles, ...emails].join();
  }
}
